// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1___9635bffbafb0a8b5404","cls2":"TagSelector-cls2___d791f55137c14f0acbc TagSelector-cls1___9635bffbafb0a8b5404"};